export default __webpack_public_path__ + "static/media/hht2_ep_18.d4f5563d.png";